import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Button, Grid, Spacer, Text, Image } from '@geist-ui/react'
import Logo from 'components/Logo'

import { ArrowLeft, ArrowRight } from '@geist-ui/react-icons'

export default function SuccessPage() {
  const { loginWithRedirect } = useAuth0()

  const successText = (
    <Grid direction="column" xs={24}>
      <Text h4>Thank you!</Text>
      <Text h4 style={{ marginTop: '0' }}>
        What happens next
      </Text>
      <Text p style={{ marginTop: '0' }}>
        We've received your enrollment request! Please allow 3 to 5 business
        days for us to process your information. If your account is eligible for
        coverage, WaterPro Water Leak Protection Plan℠ will automatically be
        added to your next water bill.
      </Text>
      <Text p style={{ marginTop: '0' }}>
        Please check your inbox for your <strong>enrollment confirmation email</strong>{' '}
        with important information about the plan and next steps.
      </Text>
      <Text p style={{ marginTop: '0' }}>
        If you need further assistance, please call support at 888-977-7481
        (Mon–Fri 8-5).
      </Text>
      <Text p font="13px" style={{ color: '#6b7280', marginTop: '8px' }}>
        Brought to you by Louisville Water
      </Text>
    </Grid>
  )

  return (
    <>
      <Grid.Container
        // justify="stretch"
        alignItems="center"
        justify="center"
      >
        <Grid
          xs={24}
          md={0}
          height="25vh"
          style={{
            background: "url('/images/waterpro-success-landscape.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: '10% 10%',
          }}
        >
          <a
            title="Link back to WaterPro homepage"
            href="https://waterproplan.com"
          >
            <Button
              auto
              shadow
              type="success"
              scale={0.85}
              style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
              }}
              icon={<ArrowLeft />}
            >
              Learn More
            </Button>
          </a>
        </Grid>

        <Grid
          direction="column"
          // alignItems="center"
          justify="flex-start"
          xs={24}
          md={0}
          style={{ padding: '2rem' }}
        >
          <Logo height="40px" />
          <Spacer h={2} />
          <Grid.Container justify="center">
            {successText}
            <Spacer h={2} />
          </Grid.Container>
          <a href="https://waterproplan.com/">
            <Button type="success" scale={0.7}>
              Done
            </Button>
          </a>
          <Image
            src="/images/waterpro_steps.png"
            style={{ marginTop: '40px', marginBottom: '100px' }}
          />
        </Grid>
      </Grid.Container>
      {/* END MOBILE */}

      <Grid.Container
        justify="stretch"
        alignItems="center"
        style={{
          padding: '2rem',
          maxWidth: '1500px',
          margin: '0 auto',
          position: 'relative',
        }}
      >
        <Grid
          direction="row"
          alignItems="center"
          xs={0}
          md={24}
          style={{ marginBottom: '2rem' }}
        >
          <Logo height="60px" />
        </Grid>

        <Grid alignItems="center" xs={0} md={12}>
          <span
            style={{
              padding: '0 5rem 0 0',
            }}
          >
            <Grid.Container justify="center" width="100%" gap={4}>
              {successText}
              <Spacer h={2} />
              <Grid.Container justify="start" width="100%" gap={2}>
                <Grid>
                  <a href="https://waterproplan.com/">
                    <Button shadow scale={0.7} type="success">
                      Done
                    </Button>
                  </a>
                </Grid>
              </Grid.Container>
            </Grid.Container>
          </span>
        </Grid>

        <Grid
          xs={0}
          md={12}
          height="27rem"
          style={{
            borderRadius: '5px',
            background: "url('/images/waterpro-home.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: '5% 5%',
          }}
        />

        <Grid xs={0} md={24} style={{ marginTop: '2rem' }}>
          {/* <Button
            shadow
            type="success"
            style={{
              position: 'absolute',
              top: '2rem',
              right: '2rem',
            }}
            onClick={loginWithRedirect}
          >
            Login
          </Button>
          <a
            title="Link back to WaterPro homepage"
            href="https://waterproplan.com"
          >
            <Button
              type="success"
              style={{
                position: 'absolute',
                top: '2rem',
                left: '2rem',
              }}
              href="https://waterproplan.com"
              icon={<ArrowLeft />}
            >
              Learn More
            </Button>
          </a> */}

          <Image
            src="/images/waterpro-steps-horizontal.png"
            style={{ maxHeight: '240px' }}
          />
        </Grid>
      </Grid.Container>
    </>
  )
}
